export enum BillStatus {
  Pending = 9,
  Paid = 10,
  Overdue = 11,
}
